import { Component, OnInit, ViewChild } from '@angular/core';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Renderer2, ElementRef ,Input} from '@angular/core';


@Component({
  selector: 'app-google-translate',
  templateUrl: './google-translate.component.html',
  styleUrls: ['./google-translate.component.scss']
})
export class GoogleTranslateComponent implements OnInit {
  language: any = 'en';
  languages = [];
  languageName: any = 'English';
  searchLang: any = '';
  userInfo: any = {};
  dynamicSettings:any;
  userInfoSubscription: Subscription;
  // lang: any  = 'en';
  @Input() settingsData: any;
  /** True when hosted by the v2 top menu: no inline/global button colours, the host styles the trigger. */
  @Input() plain = false;
  @ViewChild('scrollElement') scrollElement!: ElementRef;
  pageFrom: string = ''

  constructor(private commonSubscribeService: CommanSubscribeService, public router: Router, public route: ActivatedRoute,private renderer: Renderer2, private el: ElementRef) { }

  // changeLanguage() {
  //   this.commanSubscribeService.changeLanguage(this.language);
  //   console.log(this.language);
  // }
  ngOnChanges(): void {
    this.pageFrom = this.route.snapshot.queryParamMap.get('pageFrom');

    if (!this.plain && this.settingsData?.bg_primary_color) {
      const button = document.querySelector('.btn-primary') as HTMLElement;
      

      if (button) {
         button.style.setProperty(
            'background-color',
            this.settingsData.bg_primary_color,
            'important'
          );
          button.style.setProperty(
            'color',
            this.settingsData.font_primary_color,
            'important'
          );
      }
      document.documentElement.style.setProperty('--hover-bg-color', this.settingsData.bg_secondary_color);
      const dropDown =document.querySelector('.dropdown-menu') as HTMLElement;
      if (dropDown) {
        dropDown.style.background = this.settingsData.bg_primary_color;
        dropDown.style.color = this.settingsData.font_primary_color;
      }
      const dropItems = document.querySelectorAll('.dropdown-item');
      dropItems.forEach((item: HTMLElement) => {
        item.style.color = this.settingsData.font_primary_color;
      });
      // const activeItem =document.querySelector('.dropdown-item:active') as HTMLElement;
      // if (activeItem) {
      //   activeItem.style.background = this.settingsData.bg_primary_color;
      //   activeItem.style.color = this.settingsData.font_primary_color;
      // }
      
    }
  }
  private applyStyles() {
    this.renderer.setStyle(
      this.el.nativeElement,
      'background-color',
      this.settingsData.bgColor
    );
    this.renderer.setStyle(
      this.el.nativeElement,
      'color',
      this.settingsData.textColor
    );
  }
  ngOnInit() {
    this.language = Object.keys(this.route.snapshot.queryParams).length > 0 && this.route.snapshot.queryParams.language ? this.route.snapshot.queryParams.language : this.commonSubscribeService.getLanguage();
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    // this.language = this.commonSubscribeService.getLanguage();
    this.languages = environment.languages;
    setTimeout(() => {
      let isLang = false;
      this.languages.forEach(e => {
        if (e.code == this.language)
          isLang = true;
      })
      if (this.language && this.language != 'en' && isLang) {

        let lang = this.language;
        //  let lang = 'en';
        switch (this.language) {
          case 'en': lang = 'en'; break;
          case 'zh': lang = 'zh-CN'; break;
          case 'ja': lang = 'ja'; break;
        }
        // this.language = lang;
        this.commonSubscribeService.changeLanguage(lang);
        this.commonSubscribeService.changeLanguage(lang);

      }
    }, 2000);
    // this.languages = environment.languages;
    this.languages.forEach(e => {
      if (e.code == this.language)
        this.languageName = e.lang;
    })
    this.commonSubscribeService.googleTranslateElementInit();
  }

  clearSearch() {
    this.searchLang = '';
  }

  changeLanguage(lang) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Language ${lang.lang} Selected - ${userId}`);
    const data = {
      actionType: "network",
      metaData: {
        title: `Language ${lang.lang} Selected`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,
      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    this.languageName = lang.lang;
    this.commonSubscribeService.changeLanguage(lang.code);
    this.commonSubscribeService.changeLanguage(lang.code); // to prevent issue of no translation sometimes
  }

  ngAfterViewInit() {
    const scrollColor = this.settingsData?.font_tertiary_color;
    const scrollBackcolor = this.settingsData?.bg_tertiary_color;
    if (this.scrollElement && (scrollColor || scrollBackcolor)) {
      this.scrollElement.nativeElement.style.setProperty('--scroll-color', scrollColor);
      this.scrollElement.nativeElement.style.setProperty('--scroll-backcolor', scrollBackcolor);
    }
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }
}
